export default "__VITE_ASSET__bb8f908d__"